import { summariseBpaProgress } from "./bpaProgressSummary";

export type EditionProgressSummary = {
  complete: number;
  inProgress: number;
  notStarted: number;
  total: number;
  isEditionWide: boolean;
};

export function editionProgressSummary({
  stats,
  loadedRows,
  editionTotal,
}: {
  stats: Array<{ status: string | null }> | null;
  loadedRows: Array<{ status: string | null }>;
  editionTotal: number | null;
}): EditionProgressSummary {
  const isEditionWide = stats !== null;
  const rows = isEditionWide ? stats : loadedRows;
  const { complete, inProgress, notStarted, total } = summariseBpaProgress(rows);

  return {
    complete,
    inProgress,
    notStarted,
    total: editionTotal ?? total,
    isEditionWide,
  };
}

export function sumSubmissionCounts(
  stats: Array<{ submissionCount: number }> | null,
): number | null {
  if (stats === null) {
    return null;
  }

  return stats.reduce((sum, row) => sum + row.submissionCount, 0);
}
